<template>
  <button
    class="px-4 py-2 sm:px-8 sm:py-3.5 rounded-md transition-all duration-200 bg-btn-gradient text-white hover:opacity-90 hover:shadow-lg focus:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark"
  >
    <slot />
  </button>
</template>
